var map = {
	"./amplify-amazon-button_5.entry.js": [
		1000,
		15
	],
	"./amplify-auth-container.entry.js": [
		1001,
		16
	],
	"./amplify-auth-fields_9.entry.js": [
		1002,
		17
	],
	"./amplify-authenticator.entry.js": [
		1003,
		4
	],
	"./amplify-button_3.entry.js": [
		1004,
		18
	],
	"./amplify-chatbot.entry.js": [
		1005,
		19
	],
	"./amplify-checkbox.entry.js": [
		1006,
		20
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		1007,
		5
	],
	"./amplify-container.entry.js": [
		1008,
		21
	],
	"./amplify-federated-buttons_2.entry.js": [
		1009,
		22
	],
	"./amplify-federated-sign-in.entry.js": [
		1010,
		23
	],
	"./amplify-form-field_4.entry.js": [
		1011,
		24
	],
	"./amplify-greetings.entry.js": [
		1012,
		25
	],
	"./amplify-icon-button.entry.js": [
		1013,
		26
	],
	"./amplify-icon.entry.js": [
		1014,
		6
	],
	"./amplify-link.entry.js": [
		1015,
		27
	],
	"./amplify-nav_2.entry.js": [
		1016,
		28
	],
	"./amplify-photo-picker.entry.js": [
		1017,
		29
	],
	"./amplify-picker.entry.js": [
		1018,
		30
	],
	"./amplify-radio-button_3.entry.js": [
		1019,
		7
	],
	"./amplify-s3-album.entry.js": [
		1020,
		8
	],
	"./amplify-s3-image-picker.entry.js": [
		1021,
		9
	],
	"./amplify-s3-image.entry.js": [
		1022,
		10
	],
	"./amplify-s3-text-picker.entry.js": [
		1023,
		11
	],
	"./amplify-s3-text.entry.js": [
		1024,
		12
	],
	"./amplify-select-mfa-type.entry.js": [
		1025,
		31
	],
	"./amplify-sign-in-button.entry.js": [
		1026,
		13
	],
	"./amplify-tooltip.entry.js": [
		1027,
		32
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 983;
module.exports = webpackAsyncContext;